const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="m21.2 4.3-8.08-4a2.49 2.49 0 0 0-2.24 0l-8.08 4a2.52 2.52 0 0 0-1.39 2.24v10.91A2.52 2.52 0 0 0 2.8 19.7l8.08 4A2.43 2.43 0 0 0 12 24a2.56 2.56 0 0 0 1.12-.26l8.08-4a2.52 2.52 0 0 0 1.39-2.25V6.55A2.52 2.52 0 0 0 21.2 4.3Z" fill="currentColor"></path></svg>';
export {
  a as default
};
